import React from 'react'
import {connect} from 'react-redux'
import {fetchTowns} from '../actions/townsActions'
import {fetchCourses, setSearchState} from '../actions/coursesActions'
import {Container, Row, Col, Button, Form, Label, Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
//import Select from 'react-select';
import moment from 'moment';
//import 'moment/locale/pl';
import TownsSelect from '../components/TownsSelect'

const mapStateToProps = state => {
  return {
    coursesFilter: state.courses.filter,
    //positions: getVisibleMenuPositions(state.menu, state.user.isLogged),
    townsFrom: state.towns.allTowns,
    townsTo: state.towns.toTowns,
    townFrom: state.towns.fromTown,
    townTo: state.towns.toTown,
    agentLogin: state.user.agentLogin,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onGetAllTowns: (ownProps) => {
      dispatch(fetchTowns(ownProps.agentLogin))
    },
    onGetToTowns: (ownProps) => {
      dispatch(fetchTowns(ownProps.agentLogin, ownProps.townFrom))
    },
    onFetchCourses: (ownProps, apiRequest) => {
      dispatch(setSearchState())
      dispatch(fetchCourses(apiRequest))
    },
  }
}

class CourseFilter extends React.Component{
  constructor (props) {
    super(props)
    let townFrom=localStorage.getItem('townFrom')
    let townTo=localStorage.getItem('townTo')

    this.state = {
      formClass: props.formClass || 'filterForm',

      agentLogin: props.agentLogin,

      startDate: moment(),
      townsFrom: props.townsFrom,
      townFrom: townFrom,
      townsTo: props.townsTo,
      townTo: townTo,
      qtyNormal: 1,
      qtyReduced: 0,

      onGetAllTowns: props.onGetAllTowns,
      onGetToTowns: props.onGetToTowns,
      onFetchCourses: props.onFetchCourses,
    };
    if (this.props.coursesFilter)
      this.state={
        ...this.state,
        startDate: moment(this.props.coursesFilter.departureDate),
        townFrom: this.props.coursesFilter.startTown,
        townTo: this.props.coursesFilter.finishTown,
        qtyNormal: this.props.coursesFilter.seatsQtyNormal,
        qtyReduced: this.props.coursesFilter.seatsQtyReduced,
      }
      // alert(JSON.stringify(this.props.coursesFilter))
    this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
    this.handleInputChange=this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.reverseTowns=this.reverseTowns.bind(this);
  }

  handleChangeStartDate(date) {
    this.setState({
      startDate: date
    });
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    let cStartTown = this.state.townFrom;
    let cFinishTown = this.state.townTo;

    if (!cStartTown){
      cStartTown=this.props.townFrom
    }
    if (!cFinishTown){
      cFinishTown=this.props.townFrom
    }

    this.saveStateToLocalStorage();
    let searchReq={
      departureDate: this.state.startDate.format('YYYY-MM-DD'),
      // startTown: this.state.townFrom,
      // finishTown: this.state.townTo,
      startTown: cStartTown,
      finishTown: cFinishTown,
      seatsQtyNormal: this.state.qtyNormal,
      seatsQtyReduced: this.state.qtyReduced,
      agent: this.props.agentLogin,
    }
    // alert("Request: " + JSON.stringify(searchReq))
    this.state.onFetchCourses(this.state, searchReq)
  }

  componentDidMount() {
    //fetchTowns(this.state.agentLogin)
    //this.onGetAllTowns()
    this.state.onGetAllTowns(this.state);
  }
  componentWillUnmount(){
    this.saveStateToLocalStorage();
  }
  saveStateToLocalStorage(){
    localStorage.setItem('townFrom', this.state.townFrom);
    localStorage.setItem('townTo', this.state.townTo);
  }
  reverseTowns(){
    this.setState({
      townFrom: this.state.townTo,
      townTo: this.state.townFrom,
    })
  }
  render() {
    return (
      <Container fluid={true} className={this.state.formClass}>
      <Form>
        <Row className="align-items-center">
          <Col xs="10" sm="5">
            <Label>Odjazd:</Label>
            <TownsSelect type="text"
              value={this.state.townFrom}
              towns={this.props.townsFrom}
              placeholder="Miasto początkowe"
              name="townFrom"
              required
              onChange={this.handleInputChange}
            />
          </Col>
          <Col xs="2" sm="2" >
            <Button color="warning" size="lg" onClick={this.reverseTowns}>
            {'<>'}
            </Button>
          </Col>
          <Col xs="12" sm="5">
            <Label>Przyjazd:</Label>
            <TownsSelect
              value={this.state.townTo}
              towns={this.props.townsTo}
              placeholder="Miasto docelowe"
              name="townTo"
              required
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm="3">
            <Label>Data wyjazdu:</Label>
            <DatePicker
                className="form-control"
                selected={this.state.startDate}
//                dateFormat="DD-MM-YYYY"
                minDate={moment()}
                maxDate={moment().add(4, 'month')}
                onChange={this.handleChangeStartDate}
            />
          </Col>

          <Col xs="6" sm={{size: 2, offset:1}}>
            <Label>Ilość normalnych:</Label>
            <Input type="number"
              value={this.state.qtyNormal}
              placeholder="Ilość biletów normalnych"
              name="qtyNormal"
              required
              min="0"
              onChange={this.handleInputChange}
            />
          </Col>
          <Col xs="6" sm="2" md="2">
            <Label>Ilość ulgowych:</Label>
            <Input type="number"
              value={this.state.qtyReduced}
              placeholder="Ilość biletów ulgowych"
              name="qtyReduced"
              required
              min="0"
              onChange={this.handleInputChange}
            />
          </Col>
          <Col xs="0" sm="1">
          </Col>
          <Col xs="12" sm="auto" className="ml-sm-auto">
            <Button color="danger" size="lg" onClick={this.handleSubmit}>Szukaj połączeń</Button>
          </Col>
        </Row>
      </Form>
      </Container>
    )
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseFilter)


// WEBPACK FOOTER //
// ./src/containers/CourseFilter.js